import request from '@/utils/request'

/**
 *获取
 * @param {*} data 
 */
export function agreementInfo(data){
    return request({
        url: '/agree/agreementInfo',
        method: 'post',
        data
    })
}

/**
 *修改
 * @param {*} data 
 */
export function add(data){
    return request({
        url: '/agree/add',
        method: 'post',
        data
    })
}





// WEBPACK FOOTER //
// ./src/api/agree.js